document.addEventListener('DOMContentLoaded', () => {
  console.log('Simplified Title Updater: Initializing');
  
  // Find the title element
  const titleElement = document.querySelector('.product__title-heading');
  if (!titleElement) {
    console.error('Simplified Title Updater: Title element not found');
    return;
  }
  
  // Get base title without size and color
  const baseTitle = (titleElement.dataset.baseTitle || 'Opal Porcelain Tile').trim();
  console.log('Simplified Title Updater: Base title is', baseTitle);
  
  // Get the element that contains the title text
  const titleTextElement = titleElement.querySelector('.split-words') || titleElement;
  
  // Function to update title with selected variant
  function updateTitle() {
    console.log('Simplified Title Updater: Updating title');
    
    // Get selected size
    let size = '';
    const sizeElements = document.querySelectorAll('.size-option.selected, input[name="Size"]:checked, [data-option-name="Size"][aria-checked="true"], button[data-value][aria-pressed="true"]');
    if (sizeElements.length > 0) {
      size = sizeElements[0].getAttribute('data-value') || sizeElements[0].value || sizeElements[0].getAttribute('orig-value') || sizeElements[0].textContent.trim();
      console.log('Simplified Title Updater: Selected size:', size);
    } else {
      console.log('Simplified Title Updater: No size element found');
      // Try to find selected size option in a different way
      const activeSize = document.querySelector('.variant-input--color .active');
      if (activeSize) {
        size = activeSize.textContent.trim();
        console.log('Simplified Title Updater: Found size via active class:', size);
      }
    }
    
    // Get selected color
    let color = '';
    const colorElements = document.querySelectorAll('.color-option.selected, input[name="Color"]:checked, [data-option-name="Color"][aria-checked="true"], button[data-color][aria-pressed="true"]');
    if (colorElements.length > 0) {
      color = colorElements[0].getAttribute('data-value') || colorElements[0].value || colorElements[0].getAttribute('orig-value') || colorElements[0].getAttribute('data-color') || colorElements[0].textContent.trim();
      console.log('Simplified Title Updater: Selected color:', color);
    } else {
      console.log('Simplified Title Updater: No color element found');
      // Try to find color in a different way
      const activeColor = document.querySelector('.variant-input--color .active');
      if (activeColor) {
        color = activeColor.textContent.trim();
        console.log('Simplified Title Updater: Found color via active class:', color);
      }
    }
    
    // Direct DOM inspection method - find selected elements
    if (!size || !color) {
      console.log('Simplified Title Updater: Trying direct inspection of selected elements');
      
      // Look for visually selected items
      const allButtons = document.querySelectorAll('button.variant-input');
      allButtons.forEach(button => {
        const isSelected = button.classList.contains('selected') || 
                         button.classList.contains('active') || 
                         button.getAttribute('aria-checked') === 'true' ||
                         button.getAttribute('aria-pressed') === 'true';
                         
        if (isSelected) {
          const buttonType = button.closest('[data-option-name]')?.getAttribute('data-option-name')?.toLowerCase();
          const value = button.getAttribute('data-value') || button.textContent.trim();
          
          console.log('Simplified Title Updater: Found selected button', buttonType, value);
          
          if (buttonType?.includes('size')) {
            size = value;
          } else if (buttonType?.includes('color')) {
            color = value;
          }
        }
      });
    }
    
    // As a fallback, look at URL params for size/color
    if (!size || !color) {
      const urlParams = new URLSearchParams(window.location.search);
      const variantParam = urlParams.get('variant');
      
      if (variantParam) {
        console.log('Simplified Title Updater: Found variant in URL', variantParam);
        
        // We can't know which variant this is without product data, but we can try to find it in the DOM
        const variantSelectors = document.querySelectorAll('[data-variant-id]');
        variantSelectors.forEach(selector => {
          if (selector.getAttribute('data-variant-id') === variantParam) {
            size = selector.getAttribute('data-size') || size;
            color = selector.getAttribute('data-color') || color;
          }
        });
      }
    }
    
    // Update the title if we have size and color
    if (size || color) {
      let newTitle = baseTitle;
      
      if (size) {
        newTitle += ` ${size}`;
      }
      
      if (color) {
        newTitle += ` in ${color}`;
      }
      
      console.log('Simplified Title Updater: New title:', newTitle);
      titleTextElement.textContent = newTitle;
    } else {
      console.warn('Simplified Title Updater: Could not determine size and/or color');
    }
  }
  
  // Find all potential variant selectors
  const allSelectors = document.querySelectorAll('select.single-option-selector, input[type="radio"].single-option-selector, .swatch-element, .variant-input, [data-option-selector], button[data-value]');
  
  console.log('Simplified Title Updater: Found', allSelectors.length, 'potential selectors');
  
  // Add event listeners to all potential selectors
  allSelectors.forEach(selector => {
    selector.addEventListener('change', () => {
      console.log('Simplified Title Updater: Change event detected');
      setTimeout(updateTitle, 100);
    });
    
    selector.addEventListener('click', () => {
      console.log('Simplified Title Updater: Click event detected');
      setTimeout(updateTitle, 100);
    });
  });
  
  // Add mutation observer to detect changes in selected variants
  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes' && 
         (mutation.attributeName === 'class' || 
          mutation.attributeName === 'aria-checked' ||
          mutation.attributeName === 'aria-pressed' ||
          mutation.attributeName === 'selected')) {
        shouldUpdate = true;
      }
    });
    
    if (shouldUpdate) {
      console.log('Simplified Title Updater: Detected attribute change');
      setTimeout(updateTitle, 100);
    }
  });
  
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class', 'aria-checked', 'aria-pressed', 'selected']
  });
  
  // Listen for common variant change events
  document.addEventListener('variant:change', (e) => {
    console.log('Simplified Title Updater: variant:change event detected', e);
    setTimeout(updateTitle, 100);
  });
  
  document.addEventListener('variantChange', (e) => {
    console.log('Simplified Title Updater: variantChange event detected', e);
    setTimeout(updateTitle, 100);
  });
  
  document.addEventListener('product:variant:change', (e) => {
    console.log('Simplified Title Updater: product:variant:change event detected', e);
    setTimeout(updateTitle, 100);
  });
  
  // Run update on page load
  setTimeout(updateTitle, 300);
  
  // Run update when add to cart button is clicked (user might have changed variants)
  const addToCartButton = document.querySelector('[name="add"], .add-to-cart, #AddToCart');
  if (addToCartButton) {
    addToCartButton.addEventListener('click', () => {
      console.log('Simplified Title Updater: Add to cart clicked');
      updateTitle();
    });
  }
  
  console.log('Simplified Title Updater: Initialization complete');
});